import styles from "./global-privacy-control-popup.module.css"

import {clsx} from "clsx";
import React from "react";
import {useGPCPopup} from "./useGPCPopup";

type PrivacyControlPopupModel ={
    gpcPopupCopy: string
} 

const GlobalPrivacyControlPopup = (props: PrivacyControlPopupModel) => {
    const {
        gpcPopupCopy
    } = props;

    const [showPopup, setShowPopup] = useGPCPopup();

    if (gpcPopupCopy === null || gpcPopupCopy === undefined || gpcPopupCopy.length === 0) {
        return (
            <p>Please configure GPC Popup Component</p>
        );
    }

    if(!showPopup){
        return <></>
    }

    return (
        <div className={clsx(styles.globalPrivacyControlPopupWrapper, {[styles.active]: showPopup})}>
            <div className={styles.gpcPopup}>
                <div className={styles.box}>
                    <div className={styles.gpcOverlay}>
                        <div>
                            <button
                                aria-label="Close"
                                className={clsx(styles.close, styles.button)}
                                onClick={() => setShowPopup(false)}
                                type="button" />
                        </div>

                        <div>
                            <div
                                className={styles.gpcDescription}
                                dangerouslySetInnerHTML={{"__html": gpcPopupCopy}} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export {GlobalPrivacyControlPopup};
